import { AdminLayout } from "@/components/layout/AdminLayout";

const UpdateUsersData = () => {
  return (
    <AdminLayout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h2 className="text-3xl font-bold text-foreground">
            Update Users Data
          </h2>
        </div>
        <div className="rounded-lg border border-border bg-card p-6">
          <p className="text-muted-foreground">
            Feature to update user profiles and metadata.
          </p>
          {/* Content will be implemented here */}
        </div>
      </div>
    </AdminLayout>
  );
};

export default UpdateUsersData;
